import styled from 'styled-components';
import pulseKeyframes from '../../../styles/pulseKeyframes';

const PlaceholderContainer = styled.div`
    animation: ${pulseKeyframes} 1s infinite ease-in-out;
`;

export default PlaceholderContainer;
